import { render, staticRenderFns } from "./MobileHeaderComponent.vue?vue&type=template&id=3a8e60d5&scoped=true&lang=pug&"
import script from "./MobileHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./MobileHeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./MobileHeaderComponent.vue?vue&type=style&index=0&id=3a8e60d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e60d5",
  null
  
)

export default component.exports